import api from '../lib/api';
import type { ApiResponse } from '@maios/shared';

export interface UserListItem {
  id: string;
  name: string;
  email: string;
  role: string;
  createdAt: string;
  emailVerifiedAt: string | null;
  organizationCount: number;
  organizations: Array<{ id: string; name: string; role: string }>;
}

export interface UserListResponse {
  items: UserListItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface UserListParams {
  page?: number;
  limit?: number;
  search?: string;
  emailVerified?: string;
}

export interface UserDetail {
  user: {
    id: string;
    name: string;
    email: string;
    role: string;
    avatarUrl: string | null;
    emailVerifiedAt: string | null;
    createdAt: string;
    isDeactivated: boolean;
  };
  organizations: Array<{ id: string; name: string; slug: string; role: string; joinedAt: string }>;
  projects: Array<{ id: string; name: string; projectKey: string; role: string }>;
}

export async function getUsers(params: UserListParams): Promise<UserListResponse> {
  const query = new URLSearchParams();
  if (params.page) query.set('page', String(params.page));
  if (params.limit) query.set('limit', String(params.limit));
  if (params.search) query.set('search', params.search);
  if (params.emailVerified) query.set('emailVerified', params.emailVerified);

  const res = await api.get<ApiResponse<UserListResponse>>(`/admin/users?${query}`);
  return res.data.data!;
}

export async function getUser(id: string): Promise<UserDetail> {
  const res = await api.get<ApiResponse<UserDetail>>(`/admin/users/${id}`);
  return res.data.data!;
}
